import React from "react";
import { Link } from "react-router-dom";

export const EventCard = ({ events }) => {

  
  return (
    <div className="w-full mx-auto grid gap-3 sm:gap-4 grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
      {events.map((event) => (
        <div
          key={event.id}
          className="w-full border border-border_color p-3 rounded-xl"
        >
          {/* Image */}
          <div className="w-full h-[192px] ">
            <div className="relative h-[192px] rounded overflow-hidden block">
              <img
                alt={event.title}
                className="object-cover object-center w-full h-full block rounded-xl"
                src={event.image}
              />
               <span className="text-sm text-black font-medium font-grotesk absolute top-4 right-4 bg-white px-2 py-1 rounded-full shadow-md">
            {event.status == 'enable' ? 'Active':'InActive'}
          </span>
            </div>
          </div>

          

          {/* Content */}
          <div className="mt-[6px]">
            <span className="font-bold text-[16px] text-[#262626] font-grotesk tracking-wide line-clamp-1">
              {event.title} 
            </span>
            <p className="text-[#696565] text-sm font-grotesk font-medium line-clamp-2">
              {event.description}
            </p>

            <div className="flex items-center justify-center gap-2 w-full mt-2">
              <Link
                to={
                  `/admin/edit-event/${event.id}`

                }
                className="w-full flex items-center justify-center text-[14px] font-bold border border-border_color font-grotesk text-primary py-3 px-5 rounded-[10px] whitespace-nowrap tracking-wide hover:text-white hover:bg-primary transition-all delay-75"
              >
                 View
              </Link>
            </div>
          </div>
        </div>
      )
      )}
    </div>
  );
};
